import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import BackService from "@/core/services/back.service";
// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";

export const APP_VERIFY_AUTH = "appVerifyAuth";
export const APP_LOGIN = "appLogin";
export const APP_LOGOUT = "appLogout";
export const APP_REGISTER = "appRegister";
export const APP_UPDATE_USER = "appUpdateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";

export const APP_PURGE_AUTH = "appLogOut";
export const APP_SET_AUTH = "appSetUser";
export const APP_SET_ERROR = "appSetError";

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!BackService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("login", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [APP_LOGIN](context, credentials) {
    return new Promise(resolve => {
      BackService.ajax('/authorization/create',credentials, (res) => {
        if(res.status === true){
          context.commit(APP_SET_AUTH,res.data);
          resolve(res.data);
        }else{
          context.commit(APP_SET_ERROR,res.data)
        }
      })
    })
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [APP_LOGOUT](context) {
    context.commit(APP_PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("users", { user: credentials })
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  [APP_REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {
      BackService.ajax('/test/ping',null, (res) => {
        console.log(credentials);
        if(res.status === true){
          //context.commit(APP_SET_ERROR, res.data);
          resolve(res.data);
        }else{
          context.commit(SET_ERROR, res.data);
          reject(res.data);
        }
      });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get("verify")
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [APP_VERIFY_AUTH](context) {
    const token = BackService.getToken();
    const user = BackService.getUser();
    if(token && user){
      context.commit(APP_SET_AUTH,user)
    }else if (token) {
      BackService.ajax('/authorization/verify',null, (res) => {
        if(res.status === true){
          context.commit(APP_SET_AUTH,res.data)
        }
      });
    }else {
      context.commit(APP_PURGE_AUTH);
    }
  },
  [UPDATE_USER](context, payload) {
    const { email, username, password, image, bio } = payload;
    const user = { email, username, bio, image };
    if (password) {
      user.password = password;
    }

    return ApiService.put("user", user).then(({ data }) => {
      context.commit(SET_AUTH, data);
      return data;
    });
  },
  [APP_UPDATE_USER](context, credentials) {
    return new Promise((resolve, reject) => {
      BackService.ajax('/test/ping',null, (res) => {
        console.log(credentials);
        if(res.status === true){
          context.commit(APP_SET_ERROR, res.data);
          resolve(res.data);
        }else{
          context.commit(SET_ERROR, res.data);
          reject(res.data);
        }
      });
    })
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [APP_SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    JwtService.saveToken(state.user.token);
  },
  [APP_SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    BackService.saveToken(state.user.token);
    BackService.saveUser(state.user);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
  },
  [APP_PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    BackService.destroyToken();
    BackService.destroyUser();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
